<template>
  <div class="pa-2" :class="{ 'print-mode': printMode }">
    <v-row class="legend" align="center" no-gutters>
      <!-- カラーボックス -->
      <v-col cols="auto">
        <v-sheet class="legend-color"></v-sheet>
      </v-col>

      <!-- 説明文 -->
      <v-col>
        <div class="legend-text">
          欄は、書面交付義務における記載必須項目。申込者は太枠内を記入します。
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col :cols="12">
        <dd-sub-header>
          Ⅰ 運送契約の当事者等
        </dd-sub-header>
      </v-col>
    </v-row>

    <v-row no-gutters align-content="center">
      <v-simple-table class="simple-table px-2" dense style="overflow: auto;">
        <template v-slot:default>
          <tbody>
            <tr>
              <td colspan="4" class="no-border-cell"></td>
              <td class="thick-cell-top thick-cell-left" style="width:5vw"><div class="form-label required-label">申込日</div></td>
              <td class="thick-cell-top thick-cell-right">
                <dd-date-box
                  v-if="!hacchuFlg"
                  noLabel
                  v-model="rec.uketsukeYmd"
                  ref="uketsukeYmd"
                  :emphasis="true"
                  :required="false"
                  :readonly="readOnly"
                  max="2999/12/31"
                  min="2000/01/01"
                  tooltipText="必須項目です。<br>運送申込があった日付を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  multiline
                />
                <dd-date-box
                  v-else
                  noLabel
                  v-model="rec.hacchuYmd"
                  ref="hacchuYmd"
                  :emphasis="true"
                  :required="false"
                  :readonly="readOnly"
                  max="2999/12/31"
                  min="2000/01/01"
                  tooltipText="必須項目です。<br>依頼する日付を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  multiline
                />
              </td>
            </tr>
            <tr>
              <td rowspan="5" class="thick-cell-top thick-cell-left" style="width:10vw"><div class="form-label">申込者</div></td>
              <td rowspan="2" class="thick-cell-top" style="width:5vw"><div class="form-label required-label">社名又は<br/>氏名</div></td>
              <td rowspan="2" class="thick-cell-top" style="width:40vw;">
                <dd-code-text-box
                  v-if="!hacchuFlg"
                  noLabel
                  v-model="rec.tokuisakiId"
                  ref="tokuisakiId"
                  :readonly="readOnly"
                  :valueType="Ctrls.InputTypes.Alphanumeric"
                  titleText="取引先マスタ検索"
                  :headerList="mstTorihikisakiHeaders"
                  item-value="torihikisakiCd"
                  item-text="torihikisakiNm"
                  returnValueName="id"
                  @input="changeTorihikisaki"
                  borderless
                  revealOnFocus
                  :itemList="filteredMstTokuisakiList"
                  tooltipText="必須項目です。<br>この受注の顧客を入力しましょう。請求先としても使用されます。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  multiline
                />
                <dd-text-area
                  v-else
                  noLabel
                  v-model="rec.jishaKaishaNm"
                  ref="jishaKaishaNm"
                  :length="300"
                  :rows="3"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="自社の会社名が表示されます。<br>訂正する場合は基本情報マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                />
              </td>
              <td class="thick-cell-top" style="width:5vw"><div class="form-label">電話</div></td>
              <td colspan="2" class="thick-cell-right" style="width:40vw">
                <dd-text-area
                  v-if="!hacchuFlg"
                  noLabel
                  v-model="rec.ninushiTelNo"
                  ref="ninushiTelNo"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="選択された顧客の電話番号が表示されます。<br>訂正する場合は、取引先マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  auto-grow
                  rows="1"
                />
                <dd-text-area
                  v-else
                  noLabel
                  v-model="rec.jishaTelNo"
                  ref="jishaTelNo"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="自社の電話番号が表示されます。<br>訂正する場合は基本情報マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  auto-grow
                  rows="1"
                />
              </td>
            </tr>
            <tr>
              <td><div class="form-label">FAX</div></td>
              <td colspan="2" class="thick-cell-right">
                <dd-text-area
                  v-if="!hacchuFlg"
                  noLabel
                  v-model="rec.ninushiFaxNo"
                  ref="ninushiFaxNo"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="選択された顧客のFAX番号が表示されます。<br>訂正する場合は、取引先マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  auto-grow
                  rows="1"
                />
                <dd-text-area
                  v-else
                  noLabel
                  v-model="rec.jishaFaxNo"
                  ref="jishaFaxNo"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="自社のFAX番号が表示されます。<br>訂正する場合は基本情報マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  auto-grow
                  rows="1"
                />
              </td>
            </tr>
            <tr>
              <td rowspan="2"><div class="form-label required-label">住所</div></td>
              <td rowspan="2">
                <dd-text-area
                  v-if="!hacchuFlg"
                  noLabel
                  v-model="rec.ninushiJusho"
                  ref="ninushiJusho"
                  :length="300"
                  :rows="3"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="選択された顧客の住所が表示されます。<br>訂正する場合は、取引先マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                />
                <dd-text-area
                  v-else
                  noLabel
                  v-model="rec.jishaJusho"
                  ref="jishaJusho"
                  :length="300"
                  :rows="3"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="自社の住所が表示されます。<br>訂正する場合は基本情報マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                />
              </td>
              <td><div class="form-label">E-mail</div></td>
              <td colspan="2" class="thick-cell-right">
                <dd-text-area
                  v-if="!hacchuFlg"
                  noLabel
                  v-model="rec.ninushiMailAddress"
                  ref="ninushiMailAddress"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="選択された顧客のメールアドレスが表示されます。<br>訂正する場合は、取引先マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  auto-grow
                  rows="1"
                />
                <dd-text-area
                  v-else
                  noLabel
                  v-model="rec.jishaMailAddress"
                  ref="jishaMailAddress"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="自社のメールアドレスが表示されます。<br>訂正する場合は基本情報マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  auto-grow
                  rows="1"
                />
              </td>
            </tr>
            <tr>
              <td><div class="form-label">【担当者名】</div></td>
              <td colspan="2" class="thick-cell-right">
                <dd-text-area
                  v-if="!hacchuFlg"
                  noLabel
                  v-model="rec.ninushiTantoshaNm"
                  ref="ninushiTantoshaNm"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="選択された顧客先の担当者名が表示されます。<br>訂正する場合は、取引先マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  auto-grow
                  rows="1"
                />
                <dd-text-area
                  v-else
                  noLabel
                  v-model="rec.jishaShanaiTantosha"
                  ref="jishaShanaiTantosha"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="自社の担当者名が表示されます。<br>訂正する場合は基本情報マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  auto-grow
                  rows="1"
                />
              </td>
            </tr>
            <tr>
              <td colspan="5" class="thick-cell-right"><div class="form-label">標準貨物自動車運送約款の内容について承諾しました。</div></td>
            </tr>
            <tr>
              <td rowspan="4" class="thick-cell-left"><div class="form-label">荷受人</div></td>
              <td rowspan="2"><div class="form-label">社名又は<br/>氏名</div></td>
              <td rowspan="2">
                <dd-code-text-box-switch
                  :bindId.sync="rec.niukeninId"
                  :bindText.sync="rec.niukeninBiko"
                  ref="niukeninId"
                  :length="100"
                  :emphasis="true"
                  :required="false"
                  :readonly="readOnly"
                  :valueType="Ctrls.InputTypes.Alphanumeric"
                  titleText="取引先マスタ検索"
                  :headerList="mstTorihikisakiHeaders"
                  item-value="torihikisakiCd"
                  item-text="torihikisakiNm"
                  returnValueName="id"
                  @input="changeNiukeninId"
                  :itemList="filteredMstTokuisakiList"
                  tooltipText="荷受人先の顧客名を入力しましょう。<br>手入力もしくは取引先マスタから選択できます。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  revealOnFocus
                  :switchless="printMode"
                  :manualInput="niukeninManualDisp"
                  multiline
                />
              </td>
              <td><div class="form-label">電話</div></td>
              <td colspan="2" class="thick-cell-right">
                <dd-text-area
                  noLabel
                  v-model="rec.niukeninTelNo"
                  ref="niukeninTelNo"
                  :length="15"
                  :valueType="Ctrls.InputTypes.AlphanumericWithSymbol"
                  inputType="tel"
                  :readonly="readOnly"
                  tooltipText="荷受人先の電話番号を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  auto-grow
                  rows="1"
                />
              </td>
            </tr>
            <tr>
              <td><div class="form-label">FAX</div></td>
              <td colspan="2" class="thick-cell-right">
                <dd-text-area
                  noLabel
                  v-model="rec.niukeninFaxNo"
                  ref="niukeninFaxNo"
                  :length="15"
                  :valueType="Ctrls.InputTypes.AlphanumericWithSymbol"
                  inputType="tel"
                  :readonly="readOnly"
                  tooltipText="荷受人先のFAX番号を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  auto-grow
                  rows="1"
                />
              </td>
            </tr>
            <tr>
              <td rowspan="2"><div class="form-label">住所</div></td>
              <td rowspan="2">
                <dd-text-area
                  noLabel
                  v-model="rec.niukeninJusho"
                  ref="niukeninJusho"
                  :length="300"
                  :rows="3"
                  :readonly="readOnly"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="荷受人先の住所を入力しましょう。<br>改行して、複数行入力することができます。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                />
              </td>
              <td><div class="form-label">E-mail</div></td>
              <td colspan="2" class="thick-cell-right">
                <dd-text-area
                  noLabel
                  v-model="rec.niukeninMailAddress"
                  ref="niukeninMailAddress"
                  :readonly="readOnly"
                  :length="250"
                  :valueType="Ctrls.InputTypes.AlphanumericWithSymbol"
                  tooltipText="荷受人先のメールアドレスを入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  auto-grow
                  rows="1"
                />
              </td>
            </tr>
            <tr>
              <td class="thick-cell-bottom"><div class="form-label">【担当者名】</div></td>
              <td colspan="2" class="thick-cell-bottom thick-cell-right">
                <dd-text-area
                  noLabel
                  v-model="rec.niukeninTantoshaNm"
                  ref="niukeninTantoshaNm"
                  :readonly="readOnly"
                  :length="50"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="荷受人先の担当者名を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  auto-grow
                  rows="1"
                />
              </td>
            </tr>
            <tr>
              <td rowspan="4" class="thick-cell-bottom thick-cell-left"><div class="form-label">運送を<br/>引き受ける者</div></td>
              <td rowspan="2"><div class="form-label required-label">社名又は<br/>氏名</div></td>
              <td rowspan="2" class="thick-cell-right">
                <dd-text-area
                  v-if="!hacchuFlg"
                  noLabel
                  v-model="rec.jishaKaishaNm"
                  ref="jishaKaishaNm"
                  :length="300"
                  :rows="3"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="自社の会社名が表示されます。<br>訂正する場合は基本情報マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                />
                <dd-code-text-box
                  v-else
                  noLabel
                  v-model="rec.hacchusakiId"
                  ref="hacchusakiId"
                  :readonly="readOnly"
                  :valueType="Ctrls.InputTypes.Alphanumeric"
                  titleText="取引先マスタ検索"
                  :headerList="mstTorihikisakiHeaders"
                  item-value="torihikisakiCd"
                  item-text="torihikisakiNm"
                  returnValueName="id"
                  @input="changeTorihikisaki"
                  borderless
                  revealOnFocus
                  :itemList="filteredMstHacchusakiList"
                  tooltipText="必須項目です。<br>この運送の依頼先を入力しましょう。支払先としても使用されます。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  multiline
                />
              </td>
              <td><div class="form-label" v-if="!hacchuFlg">電話</div><div class="form-label" v-else>車番</div></td>
              <td colspan="2">
                <dd-text-area
                  v-if="!hacchuFlg"
                  noLabel
                  v-model="rec.jishaTelNo"
                  ref="jishaTelNo"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="自社の電話番号が表示されます。<br>訂正する場合は基本情報マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  auto-grow
                  rows="1"
                />
                <dd-text-area
                  v-else
                  noLabel
                  v-model="rec.shiharaiText2"
                  ref="shiharaiText2"
                  :length="50"
                  :readonly="false"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="車番を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  auto-grow
                  rows="1"
                />
              </td>
            </tr>
            <tr>
              <td><div class="form-label" v-if="!hacchuFlg">FAX</div><div class="form-label" v-else>乗務員</div></td>
              <td colspan="2">
                <dd-text-area
                  v-if="!hacchuFlg"
                  noLabel
                  v-model="rec.rra"
                  ref="jishaFaxNo"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="自社のFAX番号が表示されます。<br>訂正する場合は基本情報マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  auto-grow
                  rows="1"
                />
                <dd-text-area
                  v-else
                  noLabel
                  v-model="rec.hacchusakiTantoshaNm"
                  ref="hacchusakiTantoshaNm"
                  :length="50"
                  :readonly="false"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="乗務員を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  auto-grow
                  borderless
                  rows="1"
                />
              </td>
            </tr>
            <tr>
              <td rowspan="2" class="thick-cell-bottom"><div class="form-label required-label">住所</div></td>
              <td rowspan="2" class="thick-cell-bottom thick-cell-right">
                <dd-text-area
                  v-if="!hacchuFlg"
                  noLabel
                  v-model="rec.jishaJusho"
                  ref="jishaJusho"
                  :length="300"
                  :rows="3"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="自社の住所が表示されます。<br>訂正する場合は基本情報マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                />
                <dd-text-area
                  v-else
                  noLabel
                  v-model="rec.hacchusakiJusho"
                  ref="hacchusakiJusho"
                  :length="300"
                  :rows="3"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="選択された傭車先の住所が表示されます。<br>訂正する場合は、取引先マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                />
              </td>
              <td><div class="form-label" v-if="!hacchuFlg">E-mail</div><div class="form-label" v-else>傭車携帯</div></td>
              <td colspan="2">
                <dd-text-area
                  v-if="!hacchuFlg"
                  noLabel
                  v-model="rec.jishaMailAddress"
                  ref="jishaMailAddress"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="自社のメールアドレスが表示されます。<br>訂正する場合は基本情報マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  auto-grow
                  rows="1"
                />
                <dd-text-area
                  v-else
                  noLabel
                  v-model="rec.hacchusakiTelNo"
                  ref="hacchusakiTelNo"
                  :length="15"
                  :readonly="false"
                  inputType="tel"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="連絡先を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  auto-grow
                  rows="1"
                />
              </td>
            </tr>
            <tr>
              <td><div class="form-label" v-if="!hacchuFlg">【担当者名】</div></td>
              <td colspan="2">
                <dd-text-area
                  v-if="!hacchuFlg"
                  noLabel
                  v-model="rec.jishaShanaiTantosha"
                  ref="jishaShanaiTantosha"
                  :readonly="true"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="自社の担当者名が表示されます。<br>訂正する場合は基本情報マスタを修正してください。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  auto-grow
                  rows="1"
                />
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-row>

    <v-row no-gutters>
      <v-col :cols="12">
        <dd-sub-header>
          Ⅱ 運送の役務
        </dd-sub-header>
      </v-col>
    </v-row>

    <v-row no-gutters align-content="center">
      <v-simple-table class="simple-table px-2" dense style="overflow: auto;">
        <template v-slot:default>
          <tbody>
            <tr>
              <td class="thick-cell-top thick-cell-left" style="width:10vw"><div class="form-label required-label">集貨先/発送地</div></td>
              <td colspan="2" class="thick-cell-top" style="width:50vw">
                <dd-code-text-box-switch
                  :bindId.sync="rec.hatsuchiId"
                  :bindText.sync="rec.hatsuchiBiko"
                  ref="hatsuchiId"
                  :length="100"
                  :emphasis="true"
                  :required="false"
                  :readonly="readOnly"
                  :valueType="Ctrls.InputTypes.Alphanumeric"
                  titleText="発着地マスタ検索"
                  :headerList="mstHacchakuchiHeaders"
                  item-value="hacchakuchiCd"
                  item-text="hacchakuchiNm"
                  returnValueName="id"
                  :itemList="filteredHacchakuchiList"
                  tooltipText="集荷先/発送地を入力しましょう。<br>手入力もしくは発着地マスタから選択できます。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  revealOnFocus
                  :switchless="printMode"
                  :manualInput="hatsuchiManualDisp"
                  multiline
                />
              </td>
              <td class="thick-cell-top" style="width:10vw"><div class="form-label required-label">集貨/発送の<br/>希望日時</div></td>
              <td class="thick-cell-top thick-cell-right" style="width:30vw">
                <dd-date-time-box
                  :inputDate.sync="rec.hatsuchiYmd"
                  :inputTime.sync="rec.hatsuchiHms"
                  :inputTimeBiko.sync="rec.hatsuchiHmsBiko"
                  ref="hatsuchiYmdHms"
                  :required="false"
                  :readonly="readOnly"
                  tooltipText="集荷/発送の希望日時を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                  :clockUsable="hatsuchiHmsDisp"
                />
              </td>
            </tr>
            <tr>
              <td class="thick-cell-left"><div class="form-label required-label">配達先/到着地</div></td>
              <td colspan="2">
                <dd-code-text-box-switch
                  :bindId.sync="rec.chakuchiId"
                  :bindText.sync="rec.chakuchiBiko"
                  ref="chakuchiId"
                  :length="100"
                  :emphasis="true"
                  :required="false"
                  :readonly="readOnly"
                  :valueType="Ctrls.InputTypes.Alphanumeric"
                  titleText="発着地マスタ検索"
                  :headerList="mstHacchakuchiHeaders"
                  item-value="hacchakuchiCd"
                  item-text="hacchakuchiNm"
                  returnValueName="id"
                  :itemList="filteredHacchakuchiList"
                  tooltipText="配達先/到着地を入力しましょう。<br>手入力もしくは発着地マスタから選択できます。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  revealOnFocus
                  :switchless="printMode"
                  :manualInput="chakuchiManualDisp"
                  multiline
                />
              </td>
              <td class="thick-cell-bottom"><div class="form-label required-label">配達/到着の<br/>希望日時</div></td>
              <td class="thick-cell-bottom thick-cell-right">
                <dd-date-time-box
                  :inputDate.sync="rec.chakuchiYmd"
                  :inputTime.sync="rec.chakuchiHms"
                  :inputTimeBiko.sync="rec.chakuchiHmsBiko"
                  ref="chakuchiYmdHms"
                  :required="false"
                  :readonly="readOnly"
                  tooltipText="配達/到着の希望日時を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                  :clockUsable="chakuchiHmsDisp"
                />
              </td>
            </tr>
            <tr>
              <td class="thick-cell-bottom thick-cell-left"><div class="form-label">運送保険加入の委託</div></td>
              <td class="thick-cell-bottom thick-cell-right" style="width:25vw">
                <v-radio-group
                  style="padding-top:2px !important;justify-self: center;"
                  v-model="rec.unsoHokenKanyuItakuFlg"
                  :readonly="readOnly"
                  row
                  dense>
                  <v-radio class="mx-4" :value="true" label="有" />
                  <v-radio class="mx-4" :value="false" label="無" />
                </v-radio-group>
              </td>
              <td class="no-border-cell thick-cell-top"></td>
              <td colspan="2" class="no-border-cell"></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-row>

    <div style="height: 20px;"/>

    <v-row no-gutters align-content="center">
      <v-simple-table class="simple-table px-2" dense style="overflow: auto;">
        <template v-slot:default>
          <tbody>
            <tr>
              <td class="thick-cell-top thick-cell-left" style="width:10vw"><div class="form-label">品名</div></td>
              <td class="thick-cell-top" style="width:20vw">
                <dd-code-text-box-switch
                  :bindId.sync="rec.mstHinmeiId"
                  :bindText.sync="rec.hinmeiBiko"
                  ref="mstHinmeiId"
                  :length="100"
                  :emphasis="true"
                  :required="false"
                  :readonly="readOnly"
                  :valueType="Ctrls.InputTypes.Alphanumeric"
                  titleText="品名マスタ検索"
                  :headerList="mstHinmeiHeaders"
                  item-value="hinmeiCd"
                  item-text="hinmeiNm"
                  returnValueName="id"
                  :itemList="filteredHinmeiList"
                  tooltipText="品名を入力しましょう。<br>手入力もしくは品名マスタから選択できます。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  revealOnFocus
                  :switchless="printMode"
                  :manualInput="hinmeiManualDisp"
                  multiline
                />
              </td>
              <td class="thick-cell-top" style="width:10vw"><div class="form-label">品質</div></td>
              <td class="thick-cell-top" style="width:15vw">
                <dd-drop-down
                  v-model="rec.hinsitsuSbt"
                  placeholder="選択して下さい"
                  :items="filteredHinsitsuSbtList"
                  :readonly="readOnly"
                  tooltipText="品質を選択しましょう。<br>選択肢にない場合は、「ユーザ種別マスタ」から登録することができます。<br>種別大分類「SBT063:品質」"
                  :tooltipTop="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  revealOnFocus
                />
              </td>
              <td class="thick-cell-top" style="width:10vw"><div class="form-label">重量または容積</div></td>
              <td class="thick-cell-top" style="width:15vw">
                <v-row no-gutters dense align="center">
                  <v-col cols="8" class="px-0">
                    <dd-numeric-box
                      v-if="!hacchuFlg"
                      noLabel
                      v-model="rec.juchuJuryo"
                      ref="juchuJuryo"
                      :integerDigit="10"
                      :minorDigit="3"
                      :length="16"
                      :max=9999999999.999
                      :min=-9999999999.999
                      :readonly="readOnly"
                      tooltipText="重量または容積を入力しましょう。"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                      borderless
                      revealOnFocus
                      multiline
                    />
                    <dd-numeric-box
                      v-else
                      noLabel
                      v-model="rec.hacchuJuryo"
                      ref="hacchuJuryo"
                      :integerDigit="10"
                      :minorDigit="3"
                      :length="16"
                      :max=9999999999.999
                      :min=-9999999999.999
                      :readonly="readOnly"
                      tooltipText="重量または容積を入力しましょう。"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                      borderless
                      revealOnFocus
                      multiline
                    />
                  </v-col>
                  <v-col cols="4" class="px-0">
                    <dd-drop-down
                      v-model="rec.unitKbn"
                      placeholder="選択して下さい"
                      :items="filteredUnitKbnList"
                      :readonly="readOnly"
                      tooltipText="単位を選択しましょう。<br>選択肢にない場合は、「ユーザ種別マスタ」から登録することができます。<br>種別大分類「SVI001:単位」"
                      :tooltipTop="true"
                      :enableToolTip="helpUseFlg"
                      borderless
                      revealOnFocus
                    />
                  </v-col>
                </v-row>
              </td>
              <td class="thick-cell-top" style="width:10vw"><div class="form-label">個数</div></td>
              <td class="thick-cell-top thick-cell-right" style="width:10vw">
                <dd-numeric-box
                  v-if="!hacchuFlg"
                  noLabel
                  v-model="rec.juchuSuryo"
                  ref="juchuSuryo"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="個"
                  tooltipText="個数を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
                <dd-numeric-box
                  v-else
                  noLabel
                  v-model="rec.hacchuSuryo"
                  ref="hacchuSuryo"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="個"
                  tooltipText="個数を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
            </tr>
            <tr style="height: 50px;">
              <td class="thick-cell-bottom thick-cell-left"><div class="form-label">荷造りの種類</div></td>
              <td class="thick-cell-bottom">
                <dd-text-area
                  noLabel
                  v-model="rec.nisugataBiko"
                  ref="nisugataBiko"
                  :readonly="readOnly"
                  :length="50"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="荷造りの種類を入力しましょう。<br>例）10パレット（１パレット当たり段ボール10箱）など、荷造りの内容を入力します。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  auto-grow
                  rows="1"
                />
              </td>
              <td class="thick-cell-bottom"><div class="form-label">運送の扱種別</div></td>
              <td class="thick-cell-bottom">
                <dd-drop-down
                  v-model="rec.unsoAtsukaiSbt"
                  placeholder="選択して下さい"
                  :items="filteredUnsoAtsukaiShubetsList"
                  :readonly="readOnly"
                  tooltipText="運送扱種別を選択しましょう。<br>選択肢にない場合は、「ユーザ種別マスタ」から登録することができます。<br>種別大分類「SBT064:運送扱種別」"
                  :tooltipTop="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  revealOnFocus
                />
              </td>
              <td class="thick-cell-bottom"><div class="form-label">車種</div></td>
              <td class="thick-cell-bottom">
                <dd-drop-down
                  v-if="!hacchuFlg"
                  v-model="rec.seikyuShashuSbt"
                  placeholder="選択して下さい"
                  :items="filteredSharyoShubetsList"
                  :readonly="readOnly"
                  tooltipText="車種を選択しましょう。<br>選択肢にない場合は、「ユーザ種別マスタ」から登録することができます。<br>種別大分類「GVI011:車種」"
                  :tooltipTop="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  revealOnFocus
                />
                <dd-drop-down
                  v-else
                  v-model="rec.shiharaiShashuSbt"
                  placeholder="選択して下さい"
                  :items="filteredSharyoShubetsList"
                  :readonly="readOnly"
                  tooltipText="車種を選択しましょう。<br>選択肢にない場合は、「ユーザ種別マスタ」から登録することができます。<br>種別大分類「GVI011:車種」"
                  :tooltipTop="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  revealOnFocus
                />
              </td>
              <td class="thick-cell-bottom"><div class="form-label">台数</div></td>
              <td class="thick-cell-bottom thick-cell-right">
                <dd-numeric-box
                  v-if="!hacchuFlg"
                  noLabel
                  v-model="rec.juchuSharyoSuryo"
                  ref="juchuSharyoSuryo"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="両"
                  tooltipText="車両数を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
                <dd-numeric-box
                  v-else
                  noLabel
                  v-model="rec.hacchuSharyoSuryo"
                  ref="hacchuSharyoSuryo"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="両"
                  tooltipText="車両数を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-row>

    <v-row no-gutters>
      <v-col :cols="12">
        <dd-sub-header>
          Ⅲ 荷役作業・付帯業務等
        </dd-sub-header>
      </v-col>
    </v-row>

    <v-row no-gutters align-content="center">
      <v-simple-table class="simple-table px-2" dense style="overflow: auto;">
        <template v-slot:default>
          <tbody>
            <tr>
              <td class="thick-cell-top thick-cell-left" style="width:10vw"><div class="form-label required-label">積込み作業の委託</div></td>
              <td class="thick-cell-top" style="width:20vw">
                <v-radio-group
                  style="padding-top:2px !important;justify-self: center;"
                  v-model="rec.tsumikomiUmuFlg"
                  :readonly="readOnly"
                  row
                  dense>
                  <v-radio class="mx-4" :value="false" label="無" />
                  <v-radio class="mx-4" :value="true" label="有" />
                </v-radio-group>
              </td>
              <td class="thick-cell-top" style="width:10vw"><div class="form-label required-label">予定作業時間</div></td>
              <td class="thick-cell-top" style="width:10vw">
                <dd-text-area
                  noLabel
                  v-model="rec.tsumikomiSagyoJikan"
                  ref="tsumikomiSagyoJikan"
                  @change="inputTsumikomiSagyoJikan"
                  :length="6"
                  :valueType="Ctrls.InputTypes.TimeSpan"
                  :readonly="readOnly"
                  tooltipText="積込作業にかかる予定時間を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  auto-grow
                  rows="1"
                />
              </td>
              <td class="thick-cell-top" style="width:10vw"><div class="form-label required-label">取卸作業の委託</div></td>
              <td class="thick-cell-top" style="width:20vw">
                <v-radio-group
                  style="padding-top:2px !important;justify-self: center;"
                  v-model="rec.torioroshiUmuFlg"
                  :readonly="readOnly"
                  row
                  dense>
                  <v-radio class="mx-4" :value="false" label="無" />
                  <v-radio class="mx-4" :value="true" label="有" />
                </v-radio-group>
              </td>
              <td class="thick-cell-top" style="width:10vw"><div class="form-label required-label">予定作業時間</div></td>
              <td class="thick-cell-top thick-cell-right" style="width:10vw">
                <dd-text-area
                  noLabel
                  v-model="rec.torioroshiSagyoJikan"
                  ref="torioroshiSagyoJikan"
                  @change="inputTorioroshiSagyoJikan"
                  :length="6"
                  :valueType="Ctrls.InputTypes.TimeSpan"
                  :readonly="readOnly"
                  tooltipText="取卸作業にかかる予定時間を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  auto-grow
                  rows="1"
                />
              </td>
            </tr>
            <tr style="height:70px">
              <td class="thick-cell-bottom thick-cell-left"><div class="form-label required-label">附帯業務の内容</div></td>
              <td colspan="7" class="thick-cell-bottom thick-cell-right">
                <dd-text-area
                  noLabel
                  v-model="rec.futaiGyomuBiko"
                  ref="futaiGyomuBiko"
                  :length="300"
                  :rows="3"
                  :readonly="readOnly"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="附帯業務内容を入力しましょう。<br>改行して、複数行入力することができます。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                />
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-row>

    <v-row no-gutters>
      <v-col :cols="12">
        <dd-sub-header>
          Ⅳ 運賃及び料金
        </dd-sub-header>
      </v-col>
    </v-row>

    <v-row no-gutters align-content="center">
      <v-simple-table class="simple-table px-2" dense style="overflow: auto;">
        <template v-slot:default>
          <tbody>
            <tr>
              <td colspan="2" class="thick-cell-top thick-cell-left" style="width:10vw"><div class="form-label required-label">運賃<div style="font-size: x-small;">(※)</div></div></td>
              <td class="thick-cell-top" style="width:20vw">
                <dd-numeric-box
                  noLabel
                  v-model="rec.kihonUnchin"
                  ref="kihonUnchin"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="運賃を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td colspan="2" class="thick-cell-top" style="width:10vw"><div class="form-label required-label">燃料サーチャージ<div style="font-size: x-small;">(※)</div></div></td>
              <td colspan="2" class="thick-cell-top" style="width:20vw">
                <dd-numeric-box
                  noLabel
                  v-model="rec.nenryoSurcharge"
                  ref="nenryoSurcharge"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="燃料サーチャージを請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td colspan="2" class="thick-cell-top" style="width:10vw"><div class="form-label required-label">有料道路利用料(税込)</div></td>
              <td colspan="2" class="thick-cell-top thick-cell-right" style="width:20vw">
                <dd-numeric-box
                  noLabel
                  v-model="rec.hiwayPrice"
                  ref="hiwayPrice"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="有料道路利用料(税込)を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
            </tr>
            <tr>
              <td colspan="2" class="thick-cell-left"><div class="form-label required-label">積込料<div style="font-size: x-small;">(※)</div></div></td>
              <td>
                <dd-numeric-box
                  noLabel
                  v-model="rec.tsumikomiKingaku"
                  ref="tsumikomiKingaku"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="積込料を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td colspan="2"><div class="form-label">運賃(その他)<div style="font-size: x-small;">(※)</div></div></td>
              <td colspan="2">
                <dd-numeric-box
                  noLabel
                  v-model="rec.unchinHokaKingaku"
                  ref="unchinHokaKingaku"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="運賃(その他)を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td colspan="2" class="thick-cell-bottom"><div class="form-label">保管料<div style="font-size: x-small;">(※)</div></div></td>
              <td colspan="2" class="thick-cell-bottom thick-cell-right">
                <dd-numeric-box
                  noLabel
                  v-model="rec.hokanKingaku"
                  ref="hokanKingaku"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="保管料を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
            </tr>
            <tr>
              <td colspan="2" class="thick-cell-left"><div class="form-label required-label">取卸料<div style="font-size: x-small;">(※)</div></div></td>
              <td>
                <dd-numeric-box
                  noLabel
                  v-model="rec.torioroshiKingaku"
                  ref="torioroshiKingaku"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="取卸料を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td colspan="2"><div class="form-label">荷役料<div style="font-size: x-small;">(※)</div></div></td>
              <td colspan="2" class="thick-cell-right">
                <dd-numeric-box
                  noLabel
                  v-model="rec.niekiKingaku"
                  ref="niekiKingaku"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="荷役料を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
            </tr>
            <tr>
              <td colspan="2" class="thick-cell-left"><div class="form-label">運賃他(税込)</div></td>
              <td>
                <dd-numeric-box
                  noLabel
                  v-model="rec.unchinHokaHikazei"
                  ref="unchinHokaHikazei"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="運賃他(税込)を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td colspan="2"><div class="form-label">立替金(税込)</div></td>
              <td colspan="2" class="thick-cell-right">
                <dd-numeric-box
                  noLabel
                  v-model="rec.tatekaekinHikazei"
                  ref="tatekaekinHikazei"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="立替金(税込)を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
            </tr>
            <tr>
              <td colspan="2" class="thick-cell-left"><div class="form-label required-label">見込み待機時間</div></td>
              <td>
                <dd-text-area
                  noLabel
                  v-model="rec.taikiJikan"
                  ref="taikiJikan"
                  @change="inputTaikiJikan"
                  @blur="calcTaikiJikanKingaku"
                  :length="6"
                  :valueType="Ctrls.InputTypes.TimeSpan"
                  :readonly="readOnly"
                  tooltipText="待機時間を請求する場合に、見込み待機時間を入力しましょう。<br>待機時間×待機時間単価が待機時間料となります。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  auto-grow
                  rows="1"
                />
              </td>
              <td colspan="2"><div class="form-label required-label">待機時間単価</div></td>
              <td colspan="2">
                <dd-numeric-box
                  noLabel
                  v-model="rec.taikiJikanTanka"
                  ref="taikiJikanTanka"
                  :integerDigit="10"
                  :minorDigit="0"
                  @blur="calcTaikiJikanKingaku"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="待機時間を請求する場合に、単価を入力しましょう。<br>待機時間×待機時間単価が待機時間料となります。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td colspan="2" class="thick-cell-top"><div class="form-label required-label">待機時間料<div style="font-size: x-small;">(※)</div></div></td>
              <td colspan="2" class="thick-cell-top thick-cell-right">
                <dd-numeric-box
                  noLabel
                  v-model="rec.taikiJikanKingaku"
                  ref="taikiJikanKingaku"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="待機時間料を請求する場合に入力しましょう。<br>待機時間×待機時間単価が待機時間料となります。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
            </tr>
            <tr>
              <td colspan="2" class="thick-cell-left"><div class="form-label">割増対象時間</div></td>
              <td>
                <dd-text-area
                  noLabel
                  v-model="rec.warimashiTaishoJikan"
                  ref="warimashiTaishoJikan"
                  @change="inputWarimashiTaishoJikan"
                  @blur="calcWarimashiTaishoJikanKingaku"
                  :length="6"
                  :valueType="Ctrls.InputTypes.TimeSpan"
                  :readonly="readOnly"
                  tooltipText="割増時間を請求する場合に、割増対象時間を入力しましょう。<br>割増対象時間×割増単価(時間)が割増金額(時間)となります。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  auto-grow
                  rows="1"
                />
              </td>
              <td colspan="2"><div class="form-label">割増単価(時間)</div></td>
              <td colspan="2">
                <dd-numeric-box
                  noLabel
                  v-model="rec.warimashiJikanTanka"
                  ref="warimashiJikanTanka"
                  :integerDigit="10"
                  :minorDigit="0"
                  @blur="calcWarimashiTaishoJikanKingaku"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="割増時間を請求する場合に、単価を入力しましょう。<br>割増対象時間×割増単価(時間)が割増金額(時間)となります。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td colspan="2"><div class="form-label">割増金額(時間)<div style="font-size: x-small;">(※)</div></div></td>
              <td colspan="2" class="thick-cell-right">
                <dd-numeric-box
                  noLabel
                  v-model="rec.jikanWarimashiKingaku"
                  ref="jikanWarimashiKingaku"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="割増時間料を請求する場合に入力しましょう。<br>割増対象時間×割増単価(時間)が割増金額(時間)となります。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
            </tr>
            <tr>
              <td colspan="2" class="thick-cell-left"><div class="form-label">割増対象距離</div></td>
              <td>
                <dd-numeric-box
                  noLabel
                  v-model="rec.warimashiTaishoKyori"
                  ref="warimashiTaishoKyori"
                  :integerDigit="10"
                  :minorDigit="1"
                  :length="16"
                  suffix="km"
                  :max=9999999999.9
                  :min=-9999999999.9
                  :readonly="readOnly"
                  @blur="calcWarimashiTaishoKyoriKingaku"
                  tooltipText="割増距離を請求する場合に、割増対象距離を入力しましょう。<br>割増対象距離×割増単価(距離)が割増金額(距離)となります。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  revealOnFocus
                  multiline
                />
              </td>
              <td colspan="2" class="thick-cell-bottom"><div class="form-label">割増単価(距離)</div></td>
              <td colspan="2" class="thick-cell-bottom">
                <dd-numeric-box
                  noLabel
                  v-model="rec.warimashiKyoriTanka"
                  ref="warimashiKyoriTanka"
                  :integerDigit="10"
                  :minorDigit="0"
                  @blur="calcWarimashiTaishoKyoriKingaku"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="割増距離を請求する場合に、単価を入力しましょう。<br>割増対象距離×割増単価(距離)が割増金額(距離)となります。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td colspan="2" class="thick-cell-bottom"><div class="form-label">割増金額(距離)<div style="font-size: x-small;">(※)</div></div></td>
              <td colspan="2" class="thick-cell-bottom thick-cell-right">
                <dd-numeric-box
                  noLabel
                  v-model="rec.kyoriWarimashiKingaku"
                  ref="kyoriWarimashiKingaku"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="割増距離を請求する場合に入力しましょう。<br>割増対象距離×割増単価(距離)が割増金額(距離)となります。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
            </tr>
            <tr>
              <td colspan="2" class="thick-cell-left"><div class="form-label">割増その他<div style="font-size: x-small;">(※)</div></div></td>
              <td class="thick-cell-right">
                <dd-numeric-box
                  noLabel
                  v-model="rec.warimashiSonotaKingsku"
                  ref="warimashiSonotaKingsku"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="割増その他を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
            </tr>
            <tr>
              <td rowspan="4" class="thick-cell-left vertical-cell"><div class="form-label required-label">付帯業務料</div></td>
              <td><div class="form-label">品代金の取立て<div style="font-size: x-small;">(※)</div></div></td>
              <td>
                <dd-numeric-box
                  noLabel
                  v-model="rec.futaiGyomuKingaku1"
                  ref="futaiGyomuKingaku1"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="品代金の取立て作業料金を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td colspan="2" class="thick-cell-top"><div class="form-label">荷掛金の立替え<div style="font-size: x-small;">(※)</div></div></td>
              <td colspan="2" class="thick-cell-top">
                <dd-numeric-box
                  noLabel
                  v-model="rec.futaiGyomuKingaku2"
                  ref="futaiGyomuKingaku2"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="荷掛金の立替え作業料金を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td colspan="2" class="thick-cell-top"><div class="form-label">荷造り<div style="font-size: x-small;">(※)</div></div></td>
              <td colspan="2" class="thick-cell-top thick-cell-right">
                <dd-numeric-box
                  noLabel
                  v-model="rec.futaiGyomuKingaku3"
                  ref="futaiGyomuKingaku3"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="荷造り作業料金を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
            </tr>
            <tr>
              <td><div class="form-label">仕分け<div style="font-size: x-small;">(※)</div></div></td>
              <td>
                <dd-numeric-box
                  noLabel
                  v-model="rec.futaiGyomuKingaku4"
                  ref="futaiGyomuKingaku4"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="仕分け作業料金を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td colspan="2"><div class="form-label">保管<div style="font-size: x-small;">(※)</div></div></td>
              <td colspan="2">
                <dd-numeric-box
                  noLabel
                  v-model="rec.futaiGyomuKingaku5"
                  ref="futaiGyomuKingaku5"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="保管料金を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td colspan="2"><div class="form-label">検収及び検品<div style="font-size: x-small;">(※)</div></div></td>
              <td colspan="2" class="thick-cell-right">
                <dd-numeric-box
                  noLabel
                  v-model="rec.futaiGyomuKingaku6"
                  ref="futaiGyomuKingaku6"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="検収及び検品料金を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
            </tr>
            <tr>
              <td><div class="form-label">横持ち及び縦持ち<div style="font-size: x-small;">(※)</div></div></td>
              <td>
                <dd-numeric-box
                  noLabel
                  v-model="rec.futaiGyomuKingaku7"
                  ref="futaiGyomuKingaku7"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="横持ち及び縦持ち料金を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td colspan="2"><div class="form-label">棚入れ<div style="font-size: x-small;">(※)</div></div></td>
              <td colspan="2">
                <dd-numeric-box
                  noLabel
                  v-model="rec.futaiGyomuKingaku8"
                  ref="futaiGyomuKingaku8"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="棚入れ作業料金を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td colspan="2" class="thick-cell-bottom"><div class="form-label">ラベル貼り<div style="font-size: x-small;">(※)</div></div></td>
              <td colspan="2" class="thick-cell-bottom thick-cell-right">
                <dd-numeric-box
                  noLabel
                  v-model="rec.futaiGyomuKingaku9"
                  ref="futaiGyomuKingaku9"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="ラベル貼り作業料金を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
            </tr>
            <tr>
              <td><div class="form-label">はい作業<div style="font-size: x-small;">(※)</div></div></td>
              <td>
                <dd-numeric-box
                  noLabel
                  v-model="rec.futaiGyomuKingaku10"
                  ref="futaiGyomuKingaku10"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="はい作業料金を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td colspan="2" class="thick-cell-bottom"><div class="form-label">その他付帯業務<div style="font-size: x-small;">(※)</div></div></td>
              <td colspan="2" class="thick-cell-bottom thick-cell-right">
                <dd-numeric-box
                  noLabel
                  v-model="rec.futaiGyomuKingaku"
                  ref="futaiGyomuKingaku"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  suffix="円"
                  tooltipText="その他付帯業務作業料金を請求する場合に入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
            </tr>
            <tr>
              <td colspan="2" class="thick-cell-left"><div class="form-label required-label">消費税額<div style="font-size: x-small;">(※印項目で計算)</div></div></td>
              <td class="thick-cell-right">
                <dd-numeric-box
                  noLabel
                  v-model="kazeiTaxAmount"
                  ref="kazeiTaxAmount"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="true"
                  suffix="円"
                  tooltipText="税抜金額項目(※印)の消費税額が自動計算されます。<br>なお、ここで表示される消費税額は参考値です。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td rowspan="2" class="no-border-cell"></td>
              <td rowspan="2" class="thick-cell-top thick-cell-bottom thick-cell-left" style="width:7vw"><div class="form-label required-label">運賃及び料金の<br>支払方法</div></td>
              <td rowspan="2" colspan="2" class="thick-cell-top thick-cell-bottom">
                <dd-drop-down
                  v-if="!hacchuFlg"
                  v-model="rec.nyukinKbn"
                  placeholder="選択して下さい"
                  :items="nyukinKbnList"
                  :readonly="readOnly"
                  tooltipText="入金方法を選択しましょう。<br>「システム区分マスタ」から名称の変更ができます。<br>種別大分類「SFF061:入金条件区分」"
                  :tooltipTop="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  revealOnFocus
                />
                <dd-drop-down
                  v-else
                  v-model="rec.shiharaiHohoKbn"
                  placeholder="選択して下さい"
                  :items="nyukinKbnList"
                  :readonly="readOnly"
                  tooltipText="支払方法を選択しましょう。<br>「システム区分マスタ」から名称の変更ができます。<br>種別大分類「SFF061:入金条件区分」"
                  :tooltipTop="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  revealOnFocus
                />
              </td>
              <td rowspan="2" class="thick-cell-top thick-cell-bottom" style="width:7vw"><div class="form-label required-label">支払期日</div></td>
              <td rowspan="2" colspan="2" class="thick-cell-top thick-cell-bottom thick-cell-right">
                <dd-date-box
                  v-if="!hacchuFlg"
                  noLabel
                  v-model="rec.nyukinYoteiYmd"
                  ref="nyukinYoteiYmd"
                  :emphasis="true"
                  :required="false"
                  :readonly="readOnly"
                  max="2999/12/31"
                  min="2000/01/01"
                  tooltipText="入金期日を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  multiline
                />
                <dd-date-box
                  v-else
                  noLabel
                  v-model="rec.shiharaiYoteiYmd"
                  ref="shiharaiYoteiYmd"
                  :emphasis="true"
                  :required="false"
                  :readonly="readOnly"
                  max="2999/12/31"
                  min="2000/01/01"
                  tooltipText="支払い期日を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  multiline
                />
              </td>
              <td rowspan="2" class="no-border-cell"/>
            </tr>
            <tr>
              <td colspan="2" class="thick-cell-bottom thick-cell-left"><div class="form-label required-label">合計額</div></td>
              <td class="thick-cell-bottom thick-cell-right">
                <dd-numeric-box
                  noLabel
                  v-model="unsoKingakuGokei"
                  ref="unsoKingakuGokei"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="true"
                  suffix="円"
                  tooltipText="入力された運賃及び料金の合計額が自動計算されます。<br>なお、ここで表示される合計額は参考値です。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-row>

    <v-row no-gutters>
      <v-col :cols="12">
        <dd-sub-header>
          Ⅴ その他
        </dd-sub-header>
      </v-col>
    </v-row>

    <v-row no-gutters align-content="center">
      <v-simple-table class="simple-table px-2" dense style="overflow: auto;">
        <template v-slot:default>
          <tbody v-if="!hacchuFlg">
            <tr>
              <td style="width:20vw"><div class="form-label">集荷/発送の予定日時</div></td>
              <td style="width:30vw">
                <dd-date-time-box
                  :inputDate.sync="rec.hatsuchiYoteiYmd"
                  :inputTime.sync="rec.hatsuchiYoteiHms"
                  :inputTimeBiko.sync="rec.hatsuchiYoteiHmsBiko"
                  ref="hatsuchiYoteiYmdHms"
                  :required="false"
                  :readonly="readOnly"
                  tooltipText="集荷/発送の予定日時を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                  :clockUsable="hatsuchiYoteiHmsDisp"
                />
              </td>
              <td style="width:20vw"><div class="form-label">配達/到着地の予定日時</div></td>
              <td style="width:30vw">
                <dd-date-time-box
                  :inputDate.sync="rec.chakuchiYoteiYmd"
                  :inputTime.sync="rec.chakuchiYoteiHms"
                  :inputTimeBiko.sync="rec.chakuchiYoteiHmsBiko"
                  ref="chakuchiYoteiYmdHms"
                  :required="false"
                  :readonly="readOnly"
                  tooltipText="配達/到着の予定日時を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                  :clockUsable="chakuchiYoteiHmsDisp"
                />
              </td>
            </tr>
            <tr style="height:50px">
              <td><div class="form-label">【車両番号】</div></td>
              <td>
                <dd-code-text-box
                  noLabel
                  v-model="rec.sharyoId"
                  ref="sharyoId"
                  :readonly="readOnly || rec.keikakuJissekiUmuFlg"
                  :valueType="Ctrls.InputTypes.Alphanumeric"
                  titleText="車両マスタ検索"
                  :headerList="mstSharyoHeaders"
                  item-value="sharyoNo"
                  item-text="torokuNo"
                  returnValueName="id"
                  borderless
                  revealOnFocus
                  :itemList="filteredMstSharyoList"
                  tooltipText="この配送を行う車両を選択しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  multiline
                />
              </td>
              <td><div class="form-label">【運転者名】</div></td>
              <td>
                <dd-code-text-box
                  noLabel
                  v-model="rec.jininId"
                  ref="jininId"
                  :readonly="readOnly || rec.keikakuJissekiUmuFlg"
                  :valueType="Ctrls.InputTypes.Alphanumeric"
                  titleText="人員マスタ検索"
                  :headerList="mstJininHeaders"
                  item-value="jininCd"
                  item-text="jininNmSei"
                  returnValueName="id"
                  borderless
                  revealOnFocus
                  :itemList="filteredVwcMstJinin"
                  tooltipText="この配送を行う乗務員を選択しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  multiline
                />
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="rec.trJuchuKihonId > 0 && !rec.motoukeFlg">
            <tr>
              <td style="width:10vw"><div class="form-label">元請け事業者名</div></td>
              <td style="width:30vw" colspan="2">
                <dd-text-area
                  noLabel
                  v-model="rec.motoukeNm"
                  ref="motoukeNm"
                  :length="50"
                  :valueType="Ctrls.InputTypes.Free"
                  :readonly="readOnly"
                  tooltipText="元請け事業者名を入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  auto-grow
                  rows="1"
                />
              </td>
              <td style="width:10vw"><div class="form-label">引受者請負階層</div></td>
              <td style="width:15vw">
                <dd-numeric-box
                  noLabel
                  v-model="rec.hacchusakiUkeoiKaiso"
                  ref="hacchusakiUkeoiKaiso"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  tooltipText="発注時点の、傭車先請負階層を入力しましょう。<br>例：二次受けであれば「2」、三次受けであれば「3」を入力します。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td style="width:35vw" class="no-border-cell"></td>
            </tr>
            <tr>
              <td><div class="form-label">元請け先連絡方法</div></td>
              <td style="width:15vw">
                <dd-drop-down
                  v-model="rec.motoukeRenrakuSbt"
                  placeholder="選択して下さい"
                  :items="filteredRenrakuShudanList"
                  :readonly="readOnly"
                  tooltipText="元請け先への連絡方法を選択しましょう。<br>選択肢にない場合は、「ユーザ種別マスタ」から登録することができます。<br>種別大分類「SBT062:連絡手段」"
                  :tooltipTop="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  revealOnFocus
                />
              </td>
              <td style="width:15vw"><div class="form-label">元請け先連絡方法備考</div></td>
              <td colspan="3">
                <dd-text-area
                  noLabel
                  v-model="rec.motoukeRenrakuBiko"
                  ref="motoukeRenrakuBiko"
                  :length="100"
                  :valueType="Ctrls.InputTypes.Free"
                  :readonly="readOnly"
                  tooltipText="元請け先への連絡方法について、メモしておきたいことを入力しましょう。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  auto-grow
                  rows="1"
                />
              </td>
            </tr>
            <tr>
              <td><div class="form-label">元請け連絡先</div></td>
              <td colspan="5">
                <dd-text-area
                  noLabel
                  v-model="rec.motoukeRenrakusaki"
                  ref="motoukeRenrakusaki"
                  :length="300"
                  :rows="3"
                  :readonly="readOnly"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="元請け連絡先を入力しましょう。<br>改行して、複数行入力することができます。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                />
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td style="width:10vw"><div class="form-label">引受者請負階層</div></td>
              <td style="width:15vw">
                <dd-numeric-box
                  noLabel
                  v-model="rec.hacchusakiUkeoiKaiso"
                  ref="hacchusakiUkeoiKaiso"
                  :integerDigit="10"
                  :minorDigit="0"
                  :length="16"
                  :max=9999999999
                  :min=-9999999999
                  :readonly="readOnly"
                  tooltipText="発注時点の、傭車先請負階層を入力しましょう。<br>例：二次受けであれば「2」、三次受けであれば「3」を入力します。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                  multiline
                />
              </td>
              <td style="width:75vw" class="no-border-cell"></td>
            </tr>
            <tr>
              <td><div class="form-label">伝達事項</div></td>
              <td colspan="3">
                <dd-text-area
                  noLabel
                  v-model="rec.shiharaiBiko"
                  ref="shiharaiBiko"
                  :length="300"
                  :rows="3"
                  :readonly="readOnly"
                  :valueType="Ctrls.InputTypes.Free"
                  tooltipText="傭車先へ伝達が必要なことを記載しましょう。<br>例：配送完了後の報告先など<br>改行して、複数行入力することができます。"
                  :tooltipBottom="true"
                  :enableToolTip="helpUseFlg"
                  borderless
                />
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-row>

    <div style="height: 40px;"/>

    <v-row no-gutters>
      <div class="form-label" style="justify-content: start !important;">上記の通り運送を引き受けます。</div>
    </v-row>
    <v-row no-gutters>
      <v-col :cols="3">
        <v-simple-table class="simple-table px-2" dense style="overflow: auto;">
          <template v-slot:default>
            <tbody>
              <tr>
                <td style="width:5vw"><div class="form-label required-label">引受日</div></td>
                <td style="width:30vw">
                  <dd-date-box
                    v-if="!hacchuFlg"
                    noLabel
                    v-model="rec.juchuYmd"
                    ref="juchuYmd"
                    :emphasis="true"
                    :required="false"
                    :readonly="readOnly"
                    max="2999/12/31"
                    min="2000/01/01"
                    tooltipText="運送を引き受けた日付を入力しましょう。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                    multiline
                  />
                  <dd-date-box
                    v-else
                    noLabel
                    v-model="rec.hacchusakiHikiukeYmd"
                    ref="hacchusakiHikiukeYmd"
                    :emphasis="true"
                    :required="false"
                    :readonly="readOnly"
                    max="2999/12/31"
                    min="2000/01/01"
                    tooltipText="運送を引き受けた日付を入力しましょう。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                    multiline
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <v-col :cols="3"/>
      <v-col :cols="6" class="d-flex flex-column justify-space-between" style="border-bottom: double;">
        <div class="form-label" style="justify-content: start;">運送引受者 （貨物自動車運送事業者</div>
        <div class="form-label text-right" v-if="!hacchuFlg">{{ kaishaSignature }}</div>
        <div class="form-label text-right" v-else>{{ rec.hacchusakiSeishikiNm }}</div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import header from '@/ddv2.library/header'
import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'
import tax from '@/ddv2.library/tax'
import indexeddb from '@/ddv2.library/indexeddb'

import DdDateBox from '@/components/DdDateBox'
import DdSubHeader from '@/components/DdSubHeader'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdCodeTextBoxSwitch = () => import('@/components/DdCodeTextBoxSwitch')
const DdDateTimeBox = () => import('@/components/DdDateTimeBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdNumericBox = () => import('@/components/DdNumericBox.vue')
const DdTextArea = () => import('@/components/DdTextArea')
// const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'DdUnsoShomenInputForm',
  mixins: [flowMixin],
  components: {
    DdCodeTextBox,
    DdCodeTextBoxSwitch,
    DdDateBox,
    DdDateTimeBox,
    DdDropDown,
    DdNumericBox,
    DdSubHeader,
    DdTextArea
    // DdTextBox
  },
  props: {
    /**
     * Object
     */
    rec: Object,
    /**
     * 傭車依頼のときはtrueに
     */
    hacchuFlg: {
      type: Boolean,
      default: false
    },
    /**
     * readOnly
     */
    readOnly: {
      type: Boolean,
      default: false
    },
    /**
     * registerMode
     */
    registerMode: {
      type: Boolean,
      default: false
    },
    /**
     * deleteMode
     */
    deleteMode: {
      type: Boolean,
      default: false
    },
    /**
     * printMode
     */
    printMode: {
      type: Boolean,
      default: false
    },
    /**
     * niukeninManualDisp
     */
    niukeninManualDisp: {
      type: Boolean,
      default: true
    },
    /**
     * hatsuchiManualDisp
     */
    hatsuchiManualDisp: {
      type: Boolean,
      default: true
    },
    /**
     * chakuchiManualDisp
     */
    chakuchiManualDisp: {
      type: Boolean,
      default: true
    },
    /**
     * hinmeiManualDisp
     */
    hinmeiManualDisp: {
      type: Boolean,
      default: true
    },
    /**
     * hatsuchiHmsDisp
     */
    hatsuchiHmsDisp: {
      type: Boolean,
      default: true
    },
    /**
     * chakuchiHmsDisp
     */
    chakuchiHmsDisp: {
      type: Boolean,
      default: true
    },
    /**
     * hatsuchiYoteiHmsDisp
     */
    hatsuchiYoteiHmsDisp: {
      type: Boolean,
      default: true
    },
    /**
     * chakuchiYoteiHmsDisp
     */
    chakuchiYoteiHmsDisp: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      baseYmd: '',
      recTokuisakiInfo: {},
      recHacchusakiInfo: {},
      // ----------------------------------------------------------------------------------------------------
      // オートコンプリート定義
      // ----------------------------------------------------------------------------------------------------
      mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
      mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
      mstHinmeiHeaders: header.mstHinmeiHeaders,
      mstSharyoHeaders: header.vwCMstSharyoHeaders,
      mstJininHeaders: header.mstJininHeaders
    }
  },
  computed: {
    ...mapGetters({
      kihonJohoList: 'DDMasters/mstKihonJoho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      sharyoList: 'DDMasters/vwCMstSharyo',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      currentKaishaCode: 'users/currentKaishaCode',
      helpUseFlg: 'users/helpUseFlg'
    }),
    kaishaSignature () {
      const self = this
      if (self.kihonJohoList.length > 0) {
        return [self.kihonJohoList[0].kaishaSeishikiNm, self.kihonJohoList[0].daihyoshaYakushoku, self.kihonJohoList[0].daihyoshaSei, self.kihonJohoList[0].daihyoshaMei]
          .filter(part => part)// 空文字／null/undefined を除外
          .join(' ')
      } else {
        return ''
      }
    },
    kazeiTaxAmount () {
      // 税額計算(税抜項目のみ対象)
      let kazeiAmount = 0
      // 以下、this.recの各項目が有る場合に数値として加算
      if (this.rec.kihonUnchin) { kazeiAmount += parseFloat(this.rec.kihonUnchin, 10) }
      if (this.rec.nenryoSurcharge) { kazeiAmount += parseFloat(this.rec.nenryoSurcharge, 10) }
      if (this.rec.tsumikomiKingaku) { kazeiAmount += parseFloat(this.rec.tsumikomiKingaku, 10) }
      if (this.rec.unchinHokaKingaku) { kazeiAmount += parseFloat(this.rec.unchinHokaKingaku, 10) }
      if (this.rec.hokanKingaku) { kazeiAmount += parseFloat(this.rec.hokanKingaku, 10) }
      if (this.rec.torioroshiKingaku) { kazeiAmount += parseFloat(this.rec.torioroshiKingaku, 10) }
      if (this.rec.niekiKingaku) { kazeiAmount += parseFloat(this.rec.niekiKingaku, 10) }
      if (this.rec.taikiJikanKingaku) { kazeiAmount += parseFloat(this.rec.taikiJikanKingaku, 10) }
      if (this.rec.jikanWarimashiKingaku) { kazeiAmount += parseFloat(this.rec.jikanWarimashiKingaku, 10) }
      if (this.rec.kyoriWarimashiKingaku) { kazeiAmount += parseFloat(this.rec.kyoriWarimashiKingaku, 10) }
      if (this.rec.warimashiSonotaKingsku) { kazeiAmount += parseFloat(this.rec.warimashiSonotaKingsku, 10) }
      if (this.rec.futaiGyomuKingaku1) { kazeiAmount += parseFloat(this.rec.futaiGyomuKingaku1, 10) }
      if (this.rec.futaiGyomuKingaku2) { kazeiAmount += parseFloat(this.rec.futaiGyomuKingaku2, 10) }
      if (this.rec.futaiGyomuKingaku3) { kazeiAmount += parseFloat(this.rec.futaiGyomuKingaku3, 10) }
      if (this.rec.futaiGyomuKingaku4) { kazeiAmount += parseFloat(this.rec.futaiGyomuKingaku4, 10) }
      if (this.rec.futaiGyomuKingaku5) { kazeiAmount += parseFloat(this.rec.futaiGyomuKingaku5, 10) }
      if (this.rec.futaiGyomuKingaku6) { kazeiAmount += parseFloat(this.rec.futaiGyomuKingaku6, 10) }
      if (this.rec.futaiGyomuKingaku7) { kazeiAmount += parseFloat(this.rec.futaiGyomuKingaku7, 10) }
      if (this.rec.futaiGyomuKingaku8) { kazeiAmount += parseFloat(this.rec.futaiGyomuKingaku8, 10) }
      if (this.rec.futaiGyomuKingaku9) { kazeiAmount += parseFloat(this.rec.futaiGyomuKingaku9, 10) }
      if (this.rec.futaiGyomuKingaku10) { kazeiAmount += parseFloat(this.rec.futaiGyomuKingaku10, 10) }
      if (this.rec.futaiGyomuKingaku) { kazeiAmount += parseFloat(this.rec.futaiGyomuKingaku, 10) }

      if (kazeiAmount > 0) {
        let res = 0
        if (!this.hacchuFlg) {
          res = tax.calcTax(kazeiAmount, this.recTokuisakiInfo ? this.recTokuisakiInfo.unchinHasuKeisanKbn ?? '02' : '02', this.baseYmd)
        } else {
          res = tax.calcTax(kazeiAmount, this.recHacchusakiInfo ? this.recHacchusakiInfo.taxHasuKeisanKbn ?? '02' : '02', this.baseYmd)
        }
        return res
      } else {
        return 0
      }
    },
    unsoKingakuGokei () {
      // 税額計算(税抜項目のみ対象)
      let unsoAmount = 0
      // 以下、this.recの各項目が有る場合に数値として加算
      if (this.rec.hiwayPrice) { unsoAmount += parseFloat(this.rec.hiwayPrice, 10) }
      if (this.rec.kihonUnchin) { unsoAmount += parseFloat(this.rec.kihonUnchin, 10) }
      if (this.rec.nenryoSurcharge) { unsoAmount += parseFloat(this.rec.nenryoSurcharge, 10) }
      if (this.rec.tsumikomiKingaku) { unsoAmount += parseFloat(this.rec.tsumikomiKingaku, 10) }
      if (this.rec.unchinHokaKingaku) { unsoAmount += parseFloat(this.rec.unchinHokaKingaku, 10) }
      if (this.rec.hokanKingaku) { unsoAmount += parseFloat(this.rec.hokanKingaku, 10) }
      if (this.rec.torioroshiKingaku) { unsoAmount += parseFloat(this.rec.torioroshiKingaku, 10) }
      if (this.rec.niekiKingaku) { unsoAmount += parseFloat(this.rec.niekiKingaku, 10) }
      if (this.rec.unchinHokaHikazei) { unsoAmount += parseFloat(this.rec.unchinHokaHikazei, 10) }
      if (this.rec.tatekaekinHikazei) { unsoAmount += parseFloat(this.rec.tatekaekinHikazei, 10) }
      if (this.rec.taikiJikanKingaku) { unsoAmount += parseFloat(this.rec.taikiJikanKingaku, 10) }
      if (this.rec.jikanWarimashiKingaku) { unsoAmount += parseFloat(this.rec.jikanWarimashiKingaku, 10) }
      if (this.rec.kyoriWarimashiKingaku) { unsoAmount += parseFloat(this.rec.kyoriWarimashiKingaku, 10) }
      if (this.rec.warimashiSonotaKingsku) { unsoAmount += parseFloat(this.rec.warimashiSonotaKingsku, 10) }
      if (this.rec.futaiGyomuKingaku1) { unsoAmount += parseFloat(this.rec.futaiGyomuKingaku1, 10) }
      if (this.rec.futaiGyomuKingaku2) { unsoAmount += parseFloat(this.rec.futaiGyomuKingaku2, 10) }
      if (this.rec.futaiGyomuKingaku3) { unsoAmount += parseFloat(this.rec.futaiGyomuKingaku3, 10) }
      if (this.rec.futaiGyomuKingaku4) { unsoAmount += parseFloat(this.rec.futaiGyomuKingaku4, 10) }
      if (this.rec.futaiGyomuKingaku5) { unsoAmount += parseFloat(this.rec.futaiGyomuKingaku5, 10) }
      if (this.rec.futaiGyomuKingaku6) { unsoAmount += parseFloat(this.rec.futaiGyomuKingaku6, 10) }
      if (this.rec.futaiGyomuKingaku7) { unsoAmount += parseFloat(this.rec.futaiGyomuKingaku7, 10) }
      if (this.rec.futaiGyomuKingaku8) { unsoAmount += parseFloat(this.rec.futaiGyomuKingaku8, 10) }
      if (this.rec.futaiGyomuKingaku9) { unsoAmount += parseFloat(this.rec.futaiGyomuKingaku9, 10) }
      if (this.rec.futaiGyomuKingaku10) { unsoAmount += parseFloat(this.rec.futaiGyomuKingaku10, 10) }
      if (this.rec.futaiGyomuKingaku) { unsoAmount += parseFloat(this.rec.futaiGyomuKingaku, 10) }

      if (unsoAmount > 0) {
        const res = unsoAmount + this.kazeiTaxAmount ?? 0
        return res
      } else {
        return 0
      }
    },
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const self = this
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.tokuisakiFlg === true
      })
    },
    filteredMstHacchusakiList () {
      const self = this
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.hacchusakiFlg === true
      })
    },
    // 発着地マスタフィルター --> ここから
    filteredHacchakuchiList () {
      const self = this
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd
      })
    },
    // 品名マスタフィルター --> ここから
    filteredHinmeiList () {
      const self = this
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd
      })
    },
    // 品名マスタフィルター <-- ここまで
    // 車両マスタフィルター --> ここから
    filteredMstSharyo () {
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstSharyoList () {
      const self = this
      return self.filteredMstSharyo.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.hacchusakiFlg === false
      })
    },
    // 車両マスタフィルター <-- ここまで
    // 人員マスタフィルター --> ここから
    filteredVwcMstJinin () {
      const self = this
      return self.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd
      })
    },
    // 人員マスタフィルター <-- ここまで
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 品質フィルター
    filteredHinsitsuSbtList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT063')
    },
    // 運送扱種別フィルター
    filteredUnsoAtsukaiShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT064')
    },
    // 単位区分フィルター
    filteredUnitKbnList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SVI001')
    },
    // 連絡手段種別
    filteredRenrakuShudanList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT062')
    },
    // 入金区分フィルター
    nyukinKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF061')
    }
  },
  watch: {
  },
  beforeDestroy () {
  },
  created () {
  },
  mounted () {
    this.baseYmd = date.getCurrentDate()
  },
  methods: {
    changeTorihikisaki: function () {
      if (!this.hacchuFlg) {
        if (!this.rec.tokuisakiId) {
          this.recTokuisakiInfo = {}
          this.$set(this.rec, 'ninushiTelNo', '')
          this.$set(this.rec, 'ninushiFaxNo', '')
          this.$set(this.rec, 'ninushiJusho', '')
          this.$set(this.rec, 'ninushiMailAddress', '')
          this.$set(this.rec, 'ninushiTantoshaNm', '')
          this.$set(this.rec, 'jishaShanaiTantosha', '')
          this.$set(this.rec, 'nyukinKbn', '')
          return
        }
        console.log('changeTokuisakiId')
        this.getTorihikisakiInfo(this.rec.tokuisakiId).then((data) => {
          if (data) {
            this.recTokuisakiInfo = data.mstTokuisaki
            this.$set(this.rec, 'ninushiTelNo', data.torihikisakiKihonAddress.telNo)
            this.$set(this.rec, 'ninushiFaxNo', data.torihikisakiKihonAddress.faxNo)
            this.$set(this.rec, 'ninushiJusho', ([data.torihikisakiKihonAddress.jusho1, data.torihikisakiKihonAddress.jusho2, data.torihikisakiKihonAddress.jusho3].filter(part => part).join('\n')))
            this.$set(this.rec, 'ninushiMailAddress', data.torihikisakiKihonAddress.mailAddress)
            this.$set(this.rec, 'ninushiTantoshaNm', data.torihikisakiKihonAddress.tantoshaNm)
            this.$set(this.rec, 'nyukinKbn', data.mstSeikyusaki?.nyukinKbn)
            if (data.mstTorihikisaki.shanaiTantoshaCd) {
              const jininInfo = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoJininList, 'jininCd', data.mstTorihikisaki.shanaiTantoshaCd, this.baseYmd)
              this.$set(this.rec, 'jishaShanaiTantosha', jininInfo ? jininInfo.jininNmSei : '')
            } else {
              this.$set(this.rec, 'jishaShanaiTantosha', '')
            }
          } else {
            this.recTokuisakiInfo = {}
            this.$set(this.rec, 'ninushiTelNo', '')
            this.$set(this.rec, 'ninushiFaxNo', '')
            this.$set(this.rec, 'ninushiJusho', '')
            this.$set(this.rec, 'ninushiMailAddress', '')
            this.$set(this.rec, 'ninushiTantoshaNm', '')
            this.$set(this.rec, 'jishaShanaiTantosha', '')
            this.$set(this.rec, 'nyukinKbn', '')
          }
        })
      } else {
        if (!this.rec.hacchusakiId) {
          this.recHacchusakiInfo = {}
          this.$set(this.rec, 'hacchusakiSeishikiNm', '')
          this.$set(this.rec, 'hacchusakiTelNo', '')
          this.$set(this.rec, 'hacchusakiFaxNo', '')
          this.$set(this.rec, 'hacchusakiJusho', '')
          this.$set(this.rec, 'hacchusakiMailAddress', '')
          this.$set(this.rec, 'hacchusakiTantoshaNm', '')
          this.$set(this.rec, 'jishaShanaiTantosha', '')
          this.$set(this.rec, 'shiharaiHohoKbn', '')
          return
        }
        console.log('changeHacchusakiId')
        this.getTorihikisakiInfo(this.rec.hacchusakiId).then((data) => {
          if (data) {
            this.recHacchusakiInfo = data.mstShiharaisaki
            this.$set(this.rec, 'hacchusakiSeishikiNm', data.mstTorihikisaki.torihikisakiSeishikiNm)
            /*
            this.$set(this.rec, 'hacchusakiTelNo', data.torihikisakiKihonAddress.telNo)
            this.$set(this.rec, 'hacchusakiFaxNo', data.torihikisakiKihonAddress.faxNo)
            this.$set(this.rec, 'hacchusakiMailAddress', data.torihikisakiKihonAddress.mailAddress)
            this.$set(this.rec, 'hacchusakiTantoshaNm', data.torihikisakiKihonAddress.tantoshaNm)
            this.$set(this.rec, 'shiharaiHohoKbn', data.mstShiharaisaki?.shiharaiKbn)
            */
            this.$set(this.rec, 'hacchusakiJusho', ([data.torihikisakiKihonAddress.jusho1, data.torihikisakiKihonAddress.jusho2, data.torihikisakiKihonAddress.jusho3].filter(part => part).join('\n')))
            if (data.mstTorihikisaki.shanaiTantoshaCd) {
              const jininInfo = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoJininList, 'jininCd', data.mstTorihikisaki.shanaiTantoshaCd, this.baseYmd)
              this.$set(this.rec, 'jishaShanaiTantosha', jininInfo ? jininInfo.jininNmSei : '')
            } else {
              this.$set(this.rec, 'jishaShanaiTantosha', '')
            }
          } else {
            this.recHacchusakiInfo = {}
            /*
            this.$set(this.rec, 'hacchusakiTelNo', '')
            this.$set(this.rec, 'hacchusakiFaxNo', '')
            this.$set(this.rec, 'hacchusakiMailAddress', '')
            this.$set(this.rec, 'hacchusakiTantoshaNm', '')
            this.$set(this.rec, 'shiharaiHohoKbn', '')
            */
            this.$set(this.rec, 'hacchusakiJusho', '')
            this.$set(this.rec, 'hacchusakiSeishikiNm', '')
            this.$set(this.rec, 'jishaShanaiTantosha', '')
          }
        })
      }
    },
    changeNiukeninId: function () {
      if (!this.rec.niukeninId) { return }
      this.getTorihikisakiInfo(this.rec.niukeninId).then((data) => {
        if (data) {
          this.$set(this.rec, 'niukeninTelNo', data.torihikisakiKihonAddress.telNo)
          this.$set(this.rec, 'niukeninFaxNo', data.torihikisakiKihonAddress.faxNo)
          this.$set(this.rec, 'niukeninJusho', ([data.torihikisakiKihonAddress.jusho1, data.torihikisakiKihonAddress.jusho2, data.torihikisakiKihonAddress.jusho3].filter(part => part).join('\n')))
          this.$set(this.rec, 'niukeninMailAddress', data.torihikisakiKihonAddress.mailAddress)
          this.$set(this.rec, 'niukeninTantoshaNm', data.torihikisakiKihonAddress.tantoshaNm)
        } else {
          this.$set(this.rec, 'niukeninTelNo', '')
          this.$set(this.rec, 'niukeninFaxNo', '')
          this.$set(this.rec, 'niukeninJusho', '')
          this.$set(this.rec, 'niukeninMailAddress', '')
          this.$set(this.rec, 'niukeninTantoshaNm', '')
        }
      })
    },
    getTorihikisakiInfo: function (id) {
      return new Promise((resolve) => {
        this.HttpClient
          .post(`/api/v1/vwCMstTorihikisaki/searchChildren?id=${id}`)
          .then((data) => {
            const torihikisakiInfo = data.payload
            console.log('getTorihikisakiInfo', torihikisakiInfo)
            return resolve(torihikisakiInfo)
          })
          .catch((error) => {
            console.error('getTorihikisakiInfo error', error)
            return resolve(null)
          })
      })
    },
    inputTsumikomiSagyoJikan: function () {
      if (this.rec.tsumikomiSagyoJikan) {
        this.$set(this.rec, 'tsumikomiSagyoJikan', this.calcTime(String(this.rec.tsumikomiSagyoJikan)))
      }
    },
    inputTorioroshiSagyoJikan: function () {
      if (this.rec.torioroshiSagyoJikan) {
        this.$set(this.rec, 'torioroshiSagyoJikan', this.calcTime(String(this.rec.torioroshiSagyoJikan)))
      }
    },
    inputTaikiJikan: function () {
      if (this.rec.taikiJikan) {
        this.$set(this.rec, 'taikiJikan', this.calcTime(String(this.rec.taikiJikan)))
      }
    },
    calcTaikiJikanKingaku: function () {
      let taikiJikan = this.rec.taikiJikan
      let taikiJikanTanka = this.rec.taikiJikanTanka

      if (taikiJikan === undefined || taikiJikan === '' || taikiJikan === null) { taikiJikan = '00:00' }
      if (taikiJikanTanka === undefined || taikiJikanTanka === '' || taikiJikanTanka === null) { taikiJikanTanka = 0 }

      taikiJikan = filter.timeToMinFormatter(taikiJikan)

      const taikiJikanKingaku = this.calcFraction((taikiJikan / 60) * taikiJikanTanka)
      this.$set(this.rec, 'taikiJikanKingaku', taikiJikanKingaku)
    },
    inputWarimashiTaishoJikan: function () {
      if (this.rec.warimashiTaishoJikan) {
        this.$set(this.rec, 'warimashiTaishoJikan', this.calcTime(String(this.rec.warimashiTaishoJikan)))
      }
    },
    calcWarimashiTaishoJikanKingaku: function () {
      let warimashiTaishoJikan = this.rec.warimashiTaishoJikan
      let warimashiJikanTanka = this.rec.warimashiJikanTanka

      if (warimashiTaishoJikan === undefined || warimashiTaishoJikan === '' || warimashiTaishoJikan === null) { warimashiTaishoJikan = '00:00' }
      if (warimashiJikanTanka === undefined || warimashiJikanTanka === '' || warimashiJikanTanka === null) { warimashiJikanTanka = 0 }

      warimashiTaishoJikan = filter.timeToMinFormatter(warimashiTaishoJikan)

      const jikanWarimashiKingaku = this.calcFraction((warimashiTaishoJikan / 60) * warimashiJikanTanka)
      this.$set(this.rec, 'jikanWarimashiKingaku', jikanWarimashiKingaku)
    },
    calcWarimashiTaishoKyoriKingaku: function () {
      let warimashiTaishoKyori = this.rec.warimashiTaishoKyori
      let warimashiKyoriTanka = this.rec.warimashiKyoriTanka

      if (warimashiTaishoKyori === undefined || warimashiTaishoKyori === '' || warimashiTaishoKyori === null) { warimashiTaishoKyori = 0 }
      if (warimashiKyoriTanka === undefined || warimashiKyoriTanka === '' || warimashiKyoriTanka === null) { warimashiKyoriTanka = 0 }

      const kyoriWarimashiKingaku = this.calcFraction(warimashiTaishoKyori * warimashiKyoriTanka)
      this.$set(this.rec, 'kyoriWarimashiKingaku', kyoriWarimashiKingaku)
    },
    calcTime: function (p) {
      if (this.deleteMode) { return }
      var result = ''
      if (p.indexOf(':') !== -1) {
        p = p.replace(':', '')
      }
      if (p.length < 3) {
        result = filter.minToIntervalTimeFormatter(parseInt(p, 10))
      } else {
        var min = parseInt(p.slice(0, p.length - 2), 10) * 60 + parseInt(p.slice(-2), 10)
        result = filter.minToIntervalTimeFormatter(min)
      }
      return result
    },
    calcFraction: function (x) {
      if ([undefined, null, ''].includes(this.recTokuisakiInfo) || [undefined, null, ''].includes(this.rec.unchinHasuKeisanKbn)) {
      // 初期設定は四捨五入としておく
        x = Math.round(x)
      } else if (this.recTokuisakiInfo.unchinHasuKeisanKbn === '01') {
      // 切り捨て
        x = Math.floor(x)
      } else if (this.recTokuisakiInfo.unchinHasuKeisanKbn === '02') {
      // 四捨五入
        x = Math.round(x)
      } else if (this.recTokuisakiInfo.unchinHasuKeisanKbn === '03') {
      // 切り上げ
        x = Math.ceil(x)
      }
      return x
    }
  }
}
</script>
<style scoped>
.form-label {
  font-size: 1rem;
  font-weight: bold;
  color: #1F2B38;
   /* ブロック化して親幅いっぱいに */
  display: flex;
  width: 100%;
  height: 100%;
  /* テキストを中央寄せ */
  align-items: center;
  justify-content: center;
  text-align: center;
}
.required-label {
  background: #f8d7da;
}
.legend {
  margin: 16px 0;
}
.legend-color {
  width: 24px;
  height: 16px;
  background-color: #f8d7da;
  border: 1px solid #e0b0b0;
  border-radius: 2px;
  margin-right: 8px;
}
.legend-text {
  font-size: 14px;
  line-height: 16px;
}
/* １）セル境界をまとめる */
::v-deep .v-data-table.simple-table > .v-data-table__wrapper > table {
  border-collapse: collapse;
}
/* ２）padding 上書き＋枠線追加 */
::v-deep .v-data-table.simple-table > .v-data-table__wrapper > table tr th,
::v-deep .v-data-table.simple-table > .v-data-table__wrapper > table tr td {
  padding: 0 !important;
  border: 1px solid #ccc !important;
}
/* 枠なしセル */
::v-deep .v-data-table.simple-table
  > .v-data-table__wrapper
  > table tr td.no-border-cell {
  border: none !important;
}
/* 太枠セル */
::v-deep .v-data-table.simple-table
  > .v-data-table__wrapper
  > table tr td.thick-cell-top {
  border-top: 2px solid #333 !important;
}
::v-deep .v-data-table.simple-table
  > .v-data-table__wrapper
  > table tr td.thick-cell-bottom {
  border-bottom: 2px solid #333 !important;
}
::v-deep .v-data-table.simple-table
  > .v-data-table__wrapper
  > table tr td.thick-cell-right {
  border-right: 2px solid #333 !important;
}
::v-deep .v-data-table.simple-table
  > .v-data-table__wrapper
  > table tr td.thick-cell-left {
  border-left: 2px solid #333 !important;
}
::v-deep td.vertical-cell,
::v-deep div.form-label.vertical-cell {
  /* 縦書きモードを右から左に */
  writing-mode: vertical-rl;
  /* 漢字・かなを起立させる */
  text-orientation: upright;
  /* 必要に応じて改行を禁止 */
  white-space: nowrap;
  /* 文字間や行間を調整したい場合 */
  /* letter-spacing: 0.1em; */
  /* line-height: 1.3; */
}
::v-deep .v-input--dense > .v-input__control > .v-input__slot {
    margin-bottom: 0px !important;
}
::v-deep .v-textarea.v-text-field--box.v-text-field--single-line.v-input--dense .v-text-field__prefix,
::v-deep .v-textarea.v-text-field--box.v-text-field--single-line.v-input--dense .v-text-field__suffix,
::v-deep .v-textarea.v-text-field--box.v-text-field--single-line.v-input--dense textarea,
::v-deep .v-textarea.v-text-field--box.v-text-field--outlined.v-input--dense .v-text-field__prefix,
::v-deep .v-textarea.v-text-field--box.v-text-field--outlined.v-input--dense .v-text-field__suffix,
::v-deep .v-textarea.v-text-field--box.v-text-field--outlined.v-input--dense textarea,
::v-deep .v-textarea.v-text-field--enclosed.v-text-field--single-line.v-input--dense .v-text-field__prefix,
::v-deep .v-textarea.v-text-field--enclosed.v-text-field--single-line.v-input--dense .v-text-field__suffix,
::v-deep .v-textarea.v-text-field--enclosed.v-text-field--single-line.v-input--dense textarea,
::v-deep .v-textarea.v-text-field--enclosed.v-text-field--outlined.v-input--dense .v-text-field__prefix,
::v-deep .v-textarea.v-text-field--enclosed.v-text-field--outlined.v-input--dense .v-text-field__suffix,
::v-deep .v-textarea.v-text-field--enclosed.v-text-field--outlined.v-input--dense textarea {
  margin-top: 0 !important;
}
::v-deep .v-application--is-ltr .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
  padding-right: 0px;
}
.print-mode ::v-deep .v-text-field--solo.readonly-item>.v-input__control>.v-input__slot {
    background-color: #ffffff !important;
}
::v-deep .v-textarea.v-text-field--solo {
    padding-bottom: 0px !important;
}

</style>
